import axios from '@/lib/AxApi';

export default {
  getProtetics(params, cb)
  {
    axios.get('/rest/WorkOrders/getProtetics',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  addProtetic(params, cb)
  {
    axios.post('/rest/WorkOrders/addProtetic', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  deleteProtetic(params, cb)
  {
    axios.post('/rest/WorkOrders/deleteProtetic', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  toogleSeparators(params, cb)
  {
    axios.post('/rest/WorkOrders/toggleSeparators', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  getSeparators(params, cb)
  {
    axios.get('/rest/WorkOrders/getSeparators',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  getWorkOrders(params, cb)
  {
    axios.get('/rest/WorkOrders/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  getWorkOrderPossibleUsers(params, cb)
  {
    axios.get('/rest/WorkOrders/getWorkOrderPossibleUsers',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  saveWorkOrder(params, cb)
  {
    if(typeof params.id != 'undefined' && params.id != '')
    {
      axios.post('/rest/WorkOrders/updateRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
    else
    {
      axios.post('/rest/WorkOrders/insertRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
  },
  deleteWorkOrder(params, cb)
  {
    axios.post('/rest/WorkOrders/deleteRow', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  getTasks(params, cb)
  {
    axios.get('/rest/WorkOrderTasks/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  saveTask(params, cb)
  {
    if(typeof params.id != 'undefined' && params.id != '')
    {
      axios.post('/rest/WorkOrderTasks/updateRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
    else
    {
      axios.post('/rest/WorkOrderTasks/insertRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
  },
  deleteTask(params, cb)
  {
    axios.post('/rest/WorkOrderTasks/deleteRow', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  getExpenses(params, cb)
  {
    axios.get('/rest/WorkOrderExpenses/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  saveExpenses(params, cb)
  {
    axios.post('/rest/WorkOrderExpenses/insertRow', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  deleteExpenses(params, cb)
  {
    axios.post('/rest/WorkOrderExpenses/deleteRow', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/workorders.js